<template>
    <el-dialog title="店铺Logo" :visible.sync="centerDialogVisible" width="600px" class="shopLogo">
        <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></ShopLocalCropper>
        <div class="shopLogoBox">
            <p>店铺logo</p>
            <div class="upload cover-image" @click="openDialog">
                <div class="avatar-uploader">
                    <div class="el-upload el-upload--text">
                        <img class="uploadImgIcon" :src="require('@/common/images/other/upload.png')" v-if="!img" alt="">
                        <img :src="img.furl +'?'+timestamp" alt="" class="uploadImg" v-else-if="img.furl && img.furl +'?' + timestamp">
                        <img :src="img" alt="" class="uploadImg" v-else>
                    </div>
                    <div class="el-upload__tip">图片格式为:bmp, jpeg, jpg, gif,尺寸1：1,不可大于1M</div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="comfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import {mapGetters, mapActions} from 'vuex'
import {updateShopSet} from 'api/accountApi'
export default {
    name: 'shopLogo',
    data() {
        return {
            centerDialogVisible: false,
            img: '',
            timestamp: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [80, 80], // 截图框的宽高比例
                enlarge: 2.5, // 图片根据截图框输出比例倍数
                autoCropWidth: 110, // 默认生成截图框宽度
                autoCropHeight: 110 // 默认生成截图框高度
            }
        }
    },
    props: ['data'],
    methods: {
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        _setImage(file) {
            this.timestamp = new Date().getTime()
            this.img = file
        },
        close() {
        },
        comfirm() {
            if (this.img) {
                if (this.img.furl) {
                    delete this.img.type
                    this.img = JSON.stringify(this.img)
                } else {
                    this.img = ''
                }
                this.setLoading(true)
                updateShopSet({
                    data: {shoplogoinfo: this.img},
                    success: data => {
                        this.setLoading(false)
                        this.centerDialogVisible = false
                        this.$message.success('设置成功')
                        this.$emit('getMsg')
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            } else {
                this.$message.error('请上传店铺logo')
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        ShopLocalCropper
    },
    watch: {
        'data': {
            handler(newV) {
                if (newV) {
                    this.img = newV.shoplogourl
                    console.log(this.img)
                }
            }
        },
        deep: true
    }
}
</script>
<style lang="scss">
    .shopLogo{
        .shopLogoBox{
            display: flex;
            justify-content: space-between;
            .upload{
                .avatar-uploader{
                    display: flex;
                    .el-upload{
                        width: 110px;
                        height: 110px;
                        margin-right: 10px;
                        background: #F5F7FA;
                        line-height: 110px;
                        text-align: center;
                        .uploadImgIcon{
                            width: 21px;
                            height: 21px;
                        }
                        .uploadImg{
                            width: 110px;
                            height: 110px;
                        }
                    }
                    .el-upload__tip{
                        color: #C0C4CC;
                        font-size: 14px;
                    }
                }
            }
        }
    }
</style>
